import { form } from './../../../../formState'

import { createValidateEmail } from './hooks/createValidateEmail'
import { useValidateEmail } from './hooks/useValidateEmail'
import { useTexts } from './useTexts'

export function Email() {
  const texts = useTexts()
  const validateEmail = useValidateEmail()

  form.useAddFieldValidation<'email'>('email', async (field, _formApi) => {
    const emailValidation = await createValidateEmail(texts, field.value, validateEmail)
    return emailValidation.emailRequiredError?.message || emailValidation.emailValidError?.message
  })

  return <form.TextField label={texts.emailLabel} validateOn="change" name="email" autoFocus />
}
